import { useEffect, useState } from "react";
import QRCode from "qrcode";

export const DigitalCard = ({ data }) => {
  const [qr, setQr] = useState(null);

  useEffect(() => {
    let active = true;
    if (data?.qr_token) {
      QRCode.toDataURL(data.qr_token, {
        width: 260,
        margin: 1,
        color: { dark: "#2F557F", light: "#FFFFFF" },
      })
        .then((url) => active && setQr(url))
        .catch(() => {});
    }
    return () => { active = false; };
  }, [data?.qr_token]);

  if (!data?.access_granted || !data?.qr_token) return null;

  return (
    <div className="overflow-hidden rounded-2xl border-2 border-hz-cyan/40 bg-white shadow-sm" data-testid="digital-card">
      <div className="bg-hz-navy px-6 py-4 text-center">
        <p className="text-xs font-bold uppercase tracking-widest text-hz-turquoise">Pase de acceso digital</p>
        <p className="mt-1 text-lg font-extrabold text-white">Horizonte 2026</p>
        <p className="text-[10px] font-semibold uppercase tracking-widest text-white/70">Liderazgo con Visión Reformada</p>
      </div>
      <div className="flex flex-col items-center px-6 py-6">
        {qr ? (
          <img src={qr} alt={`Código QR de acceso de ${data.full_name}`} className="h-48 w-48 rounded-lg" data-testid="digital-card-qr" />
        ) : (
          <div className="h-48 w-48 animate-pulse rounded-lg bg-hz-gray/30" />
        )}
        <p className="mt-4 text-center text-base font-bold text-hz-ink" data-testid="digital-card-name">{data.full_name}</p>
        <p className="text-sm font-extrabold tracking-wider text-hz-navy" data-testid="digital-card-folio">{data.folio}</p>
        <span className="mt-2 rounded-full bg-hz-success/10 px-3 py-0.5 text-[11px] font-bold uppercase tracking-wide text-hz-success" data-testid="digital-card-paid">Pago confirmado</span>
        <div className="mt-3 flex flex-wrap justify-center gap-2">
          <span className="rounded-full bg-hz-cyan/10 px-3 py-1 text-xs font-semibold text-hz-blue">Evento general</span>
          {data.dinner_selected && (
            <span className="rounded-full bg-hz-cyan/10 px-3 py-1 text-xs font-semibold text-hz-blue">Cena especial</span>
          )}
          {data.workshops.map((w) => (
            <span key={w.id} className="rounded-full bg-hz-turquoise/15 px-3 py-1 text-xs font-semibold text-hz-navy" data-testid={`digital-card-workshop-${w.id}`}>
              {w.name}{w.schedule_text ? ` · ${w.schedule_text}` : ""}{w.room_name ? ` · ${w.room_name}` : ""}
            </span>
          ))}
        </div>
        <p className="mt-4 text-center text-xs leading-relaxed text-hz-ink/60">
          Presenta este pase desde tu celular o impreso para validar tus accesos. Es personal e intransferible.
        </p>
      </div>
    </div>
  );
};
